module.exports = __webpack_public_path__ + "img/welcomes-preview-bag-fanli-white.2d21fa1d.png";